export default __webpack_public_path__ + "static/media/email.5d9f12ad.svg";